import * as types from './mutation-types'
import * as actions from './actions'

const state = {
  plantContainerError: '',
  plantContainerLoading: 0,
  multiplePlantContainerError: '',
  multipleplantContainerLoading: false,
  multipleContainers: {},
  container: {},
  emptyContainer: {},
  emptyPlantContainers: [],
}

const getters = {
  plantContainerError: state => state.plantContainerError,
  plantContainerLoading: state => state.plantContainerLoading,
  container: state => state.container,
  multiplePlantContainerError: state => state.multiplePlantContainerError,
  multipleplantContainerLoading: state => state.multipleplantContainerLoading,
  multipleContainers: state => state.multipleContainers,
  emptyContainer: state => state.emptyContainer,
  emptyPlantContainers: state => state.emptyPlantContainers,
}

const mutations = {
  [types.GET_CONTAINER_REQUEST] (state) {
    state.plantContainerLoading += 1
    state.plantContainerError = ''
    state.container = {}
  },
  [types.GET_CONTAINER_SUCCESS] (state, container) {
    state.plantContainerLoading -= 1
    state.plantContainerError = ''
    state.container = container
  },
  [types.GET_CONTAINER_FAILURE] (state, plantContainerError) {
    state.plantContainerLoading -= 1
    state.plantContainerError = plantContainerError
    state.container = {}
  },

  [types.GET_MULTIPLE_CONTAINERS_REQUEST] (state) {
    state.multipleplantContainerLoading = true
    state.multiplePlantContainerError = ''
    state.multipleContainers = {}
  },
  [types.GET_MULTIPLE_CONTAINERS_SUCCESS] (state, multipleContainers) {
    state.multipleplantContainerLoading = false
    state.multiplePlantContainerError = ''
    state.multipleContainers = multipleContainers
  },
  [types.GET_MULTIPLE_CONTAINERS_FAILURE] (state, multiplePlantContainerError) {
    state.multipleplantContainerLoading = false
    state.multiplePlantContainerError = multiplePlantContainerError
    state.multipleContainers = {}
  },
  [types.GET_EMPTY_REQUEST] (state) {
    state.plantContainerLoading += 1
    state.plantContainerError = ''
    state.emptyContainer = {}
  },
  [types.GET_EMPTY_SUCCESS] (state, emptyContainer) {
    state.plantContainerLoading -= 1
    state.plantContainerError = ''
    state.emptyContainer = emptyContainer
  },
  [types.GET_EMPTY_FAILURE] (state, plantContainerError) {
    state.plantContainerLoading -= 1
    state.plantContainerError = plantContainerError
    state.emptyContainer = {}
  },
  [types.SET_EMPTY_PLANT_CONTAINER] (state, emptyPlantContainer) {
    state.emptyContainer = emptyPlantContainer
  },
  [types.SET_EMPTY_PLANT_CONTAINERS] (state, emptyPlantContainers) {
    state.emptyPlantContainers = emptyPlantContainers
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
